import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const PHONE = "+351 911 705 084";

const T = {
  en: {
    heading: ["Miguel is", "happy to walk you through it"],
    body: [
      "As one of the investment analysts at Verde Capital, I read every enquiry personally. If you are weighing up land, licensing or pre-construction costs — or you have been turned down elsewhere — tell me about the project and I will give you a straight answer on what we can do.",
      "No slides, no pressure. A short call, your numbers on the table, and an honest view on whether Verde is the right fit. If we are, you will have indicative terms within days.",
    ],
    role: "Investment Analyst",
    cta: "Book a meeting with Miguel",
    or: "Or call:",
  },
  pt: {
    heading: ["O Miguel tem", "todo o gosto em explicar-lhe"],
    body: [
      "Como um dos analistas de investimento da Verde Capital, leio pessoalmente cada pedido. Se está a avaliar terreno, licenciamento ou custos de pré-construção — ou se já lhe disseram não noutro lado — fale-me do projeto e dou-lhe uma resposta direta sobre o que podemos fazer.",
      "Sem apresentações, sem pressão. Uma chamada curta, os seus números na mesa e uma opinião honesta sobre se a Verde é a escolha certa. Se for, terá condições indicativas em dias.",
    ],
    role: "Analista de Investimento",
    cta: "Marcar uma reunião com o Miguel",
    or: "Ou ligue:",
  },
  nl: {
    heading: ["Miguel vertelt u er", "graag alles over"],
    body: [
      "Als een van de beleggingsanalisten bij Verde Capital lees ik elke aanvraag persoonlijk. Bent u nog in twijfel over grond, vergunningen of voorbouwkosten — of bent u elders afgewezen? Vertel mij over het project en u krijgt van mij een recht voor zijn raap antwoord over wat wij kunnen doen.",
      "Geen presentaties, geen druk. Een kort gesprek, uw cijfers op tafel en een eerlijke kijk op of Verde de juiste partij is. Zo ja, dan heeft u binnen enkele dagen indicatieve voorwaarden.",
    ],
    role: "Beleggingsanalist",
    cta: "Plan een gesprek met Miguel",
    or: "Of bel:",
  },
};

export default function AnalystClosing() {
  const { lang, lp } = useLang();
  const t = T[lang];
  return (
    <section className="pb-16">
      <div className="container-x">
        <div
          className="overflow-hidden rounded-3xl bg-verde-950 shadow-[0_40px_80px_-40px_rgba(7,39,29,0.6)]"
          data-testid="analyst-closing"
        >
          <div className="grid lg:grid-cols-[1.15fr_0.85fr]">
            <div className="px-6 py-10 sm:px-10 lg:py-14">
              <h2 className="font-display text-3xl font-bold leading-[1.08] text-white sm:text-4xl">
                <span className="text-mint">{t.heading[0]} </span>
                {t.heading[1]}
              </h2>
              {t.body.map((p, i) => (
                <p key={i} className="mt-4 max-w-xl text-[15px] leading-relaxed text-white/80">
                  {p}
                </p>
              ))}
              <p className="mt-7 font-display text-2xl italic text-mint/90 -rotate-2 origin-left" data-testid="analyst-signature">
                Miguel
              </p>
              <p className="mt-1 text-xs font-bold uppercase tracking-wider text-white/50">{t.role}</p>
              <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3">
                <Link
                  to={lp("/book?analyst=miguel")}
                  data-testid="analyst-cta"
                  className="inline-flex items-center gap-2 rounded-full bg-mint px-6 py-3.5 text-sm font-semibold text-verde-950 transition-colors hover:bg-white"
                >
                  {t.cta}
                </Link>
                <a
                  href={`tel:${PHONE.replace(/\s/g, "")}`}
                  data-testid="analyst-call"
                  className="text-sm font-semibold text-white underline decoration-white/40 underline-offset-4 transition-colors hover:decoration-white"
                >
                  {t.or} {PHONE}
                </a>
              </div>
            </div>
            <div className="relative min-h-[280px] lg:min-h-[460px]">
              <img
                src="/team-miguel.jpg"
                alt="Miguel, investment analyst at Verde Capital"
                className="absolute inset-0 h-full w-full object-cover object-top"
                loading="lazy"
                decoding="async"
                data-testid="analyst-photo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}